export const iconFontAwesomeHumanitarianSchool = (
	<i className="fa-solid fa-school"></i>
);
